import FormRender from './FormRenderer'

export default FormRender
